<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_CTV_ASSIGN_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử gán Merchant</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              :ranges="false"
              class="w-100"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
            <span class="icon-calendar"></span>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.assignerId"
              :options="optionsAssigner"
              placeholder="Người gán"
            />
          </div>
          <div
            class="form-group"
            v-if="
              dataUser.typeSale !== 'SALE' &&
              dataUser.typeSale !== 'AFTER_SALE' &&
              dataUser.typeSale !== 'TELESALE' &&
              dataUser.typeSale !== 'KEY_ACCOUNT'
            "
          >
            <Select2 v-model="search.saleId" :options="optionsSale" placeholder="Sale tiếp nhận" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.agentId" :options="optionsAgent" placeholder="Cộng tác viên" />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="table-responsive">
            <div class="box-header">
              Tổng: <strong class="text-primary">{{ pagination.total }}</strong> &nbsp;&nbsp;|
              &nbsp;&nbsp;
              <!-- Chưa tiếp nhận: <strong class="text-primary">{{ quantityPending }}</strong> &nbsp;&nbsp;| &nbsp;&nbsp;
              Đã tiếp nhận: <strong class="text-primary">{{ quantityReceived }}</strong>  &nbsp;&nbsp;| &nbsp;&nbsp;
              Đã hủy: <strong class="text-primary">{{ quantityCancel }}</strong>  &nbsp;&nbsp;| &nbsp;&nbsp;
              Từ chối: <strong class="text-primary">{{ quantityRefuse }}</strong> -->
            </div>
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" width="50">STT</th>
                  <th scope="col" width="">Thời gian</th>
                  <th scope="col" width="">Số lượng MC gán</th>
                  <th scope="col">Người gán</th>
                  <th scope="col">Người tiếp nhận</th>
                </tr>
              </thead>

              <tbody v-if="loading">
                <tr>
                  <td colspan="11" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr class="table-row" v-for="(item, index) in dataHistory" :key="index">
                  <td class="text-center">
                    {{ search.limit * (search.page - 1) + index + 1 }}
                  </td>
                  <td>
                    Gán: {{ item.createAt }}<br />
                    Tiếp nhận: {{ item.receivedDate }}
                  </td>
                  <td>
                    <a href="#" @click="showModalDetail(item)" data-toggle="modal"
                      >{{ item.numberOfcustomers }} MC</a
                    >
                  </td>
                  <td>
                    {{ item.assignerName }}<br />
                    <a href="">{{ item.assignerEmail }}</a>
                  </td>

                  <td>
                    {{ item.saleName }} <br />
                    <a href="">{{ item.saleEmail }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
    <!-- Modal chi tiết lịch sử-->
    <b-modal id="modal-lg" size="lg" v-model="modalDetail">
      <template #modal-header="{ close }">
        <h5>Chi tiết MC gán</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <table
        class="table table-hover table-bordered table-responsive"
        style="width: fit-content; margin: 0 auto"
        id="tableScroll"
      >
        <thead class="thead-light">
          <tr>
            <th scope="col" width="50">STT</th>
            <th scope="col">Tên merchant</th>
            <th scope="col">Số điện thoại</th>
            <th scope="col">Email</th>
            <th scope="col">Địa chỉ</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row" v-for="(item, index) in detailMC" :key="index">
            <td class="text-center">
              {{ index + 1 }}
            </td>
            <td>
              {{ item.merchantName }}
            </td>
            <td>
              {{ item.mobile }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>{{ item.address }}, {{ item.city }}</td>
          </tr>
        </tbody>
      </table>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { AgentService } from '@/services/agent.service'
  import { StaffService } from '@/services/staff.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import Config from '@/thirdParty/config'

  export default {
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataHistory: [],
        search: {
          page: 1,
          limit: 50,
        },
        pagination: {
          total: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        optionsAssigner: [],
        optionsSale: [],
        optionsAgent: [],
        optionsStatus: [
          { id: 'PENDING', text: 'Chưa tiếp nhận' },
          { id: 'RECEIVED', text: 'Đã tiếp nhận' },
          { id: 'REFUSE', text: 'Từ chối' },
          { id: 'CANCEL', text: 'Đã hủy' },
        ],
        localeData: Config.localeData,
        modalDetail: false,
        detailMC: [],
        loading: false,
      }
    },

    async created() {
      this.loading = true
      await this.getListAgent()
      await this.getListSale()
      await this.getListAssigner()
      this.fetchData()
    },

    watch: {
      'search.page': function () {
        this.$router.push({
          path: '/history-assign-mc',
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },

    methods: {
      async fetchData() {
        try {
          this.search.startDate = moment(this.dateRange.startDate)
            .startOf('day')
            .add(7, 'hours')
            .valueOf()

          this.search.endDate = moment(this.dateRange.endDate)
            .endOf('day')
            .add(7, 'hours')
            .valueOf()

          this.loading = true
          const response = await AgentService.getListHistoryAssignSale(this.search)
          if (response.success) {
            this.dataHistory = response.data
            this.pagination.total = response.meta.pagination.total
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      // list sale nhận
      async getListSale() {
        try {
          const response = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (response.success) {
            this.optionsSale = response.data.map(item => {
              return {
                id: item.userId,
                text: item.name,
              }
            })
            this.optionsSale.shift()
          }
        } catch (error) {
          console.log(error)
        }
      },
      // list ctv search
      async getListAgent() {
        try {
          const response = await AgentService.listAgentForSearch()
          if (response.success) {
            this.optionsAgent = response.data.map(item => {
              return {
                id: item.agentId,
                text: item.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getListAssigner() {
        try {
          const response = await StaffService.getListAssigner()
          if (response.success) {
            this.optionsAssigner = response.data.map(item => {
              return {
                id: item.id,
                text: item.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },

      clearSearch() {
        this.dateRange.startDate = null
        this.dateRange.endDate = null
        this.search = {
          limit: 50,
          page: 1,
        }
        this.fetchData()
      },
      // Chi tiết lịch sử
      async showModalDetail(item) {
        this.modalDetail = true
        try {
          const data = await AgentService.detailHistoryAssignMC({
            assignId: item.assignId,
          })
          if (data.success) {
            this.detailMC = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },

    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      // quantityPending () {
      //   return this.dataHistory.filter((item) => item.assignSaleStatus === 'PENDING').length
      // },
      // quantityReceived () {
      //   return this.dataHistory.filter((item) => item.assignSaleStatus === 'RECEIVED').length
      // },
      // quantityRefuse () {
      //   return this.dataHistory.filter((item) => item.assignSaleStatus === 'REFUSE').length
      // },
      // quantityCancel () {
      //   return this.dataHistory.filter((item) => item.assignSaleStatus === 'CANCEL').length
      // },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
  }
</script>
